import { createSelector } from 'reselect';
import lodash from 'lodash';

import {
    jsonHelper,
    QueryNodeRegistry
} from '@complion/query';
import PredicateField from 'binder/util/PredicateField';

const binderFoldersSelector = state => lodash.get(state, 'binder.layout.folders', []);
const binderPredicateGroupsSelector = state => lodash.get(state, 'binder.setup.fields', []);
export const binderLoadedSelector = state => lodash.get(state, 'binder.setup.loaded', false);
export const binderIsCreatedSelector = state => lodash.get(state, 'binder.creationSuccess', true);
export const binderSetupErrorsSelector = state => lodash.get(state, 'binder.setup.errors') || {};
export const binderSetupDataSourceItemsSelector = state =>  lodash.get(state, 'dataSourceItems' || {});
export const binderSetupDescriptorsSelector = state => {
    const descriptors = lodash.get(state, 'binder.setup.descriptors', {});
    return lodash.keyBy(descriptors, 'id');
};
export const errorMessagesSelector = state => lodash.get(state, 'binder.setup.errors');
export const binderSavingSelector = state => lodash.get(state, 'binder.setup.savingBinder', false);

function getRootQueryNode(binderFolders) {
    const rootFolder = lodash.find(binderFolders, folder => lodash.isNil(folder.parentId));
    let rootQueryNode = null;
    if (rootFolder) {
        const deserializedObj = jsonHelper.parse(JSON.stringify(rootFolder.query));
        rootQueryNode = QueryNodeRegistry.reconstituteDeserializedJson(deserializedObj);
    }
    return rootQueryNode;
}

export const rootQueryNodeSelector = createSelector(
    binderFoldersSelector,
    getRootQueryNode
);

export const binderSetupFieldsSelector = createSelector(
    binderPredicateGroupsSelector,
    errorMessagesSelector,
    (binderPredicateGroups, errorMessages) => {
        errorMessages = errorMessages || {};
        return lodash.map(binderPredicateGroups,
            ({ key, value }) => new PredicateField(key, value, errorMessages[key.groupId])
        );
    }
);

export const dataSourceIdSelector = (props, fieldId) => lodash.get(props, `binder.setup.fields.${fieldId}.key.value._data.dataSourceId`);
export const dataSourceTypeSelector = (props, fieldId) => lodash.get(props, `binder.setup.fields.${fieldId}.key.value._type`);
export const binderNotifiedUsersSelector = state => lodash.get(state, 'binderNotifiedUsers.users', []);
export const binderNotifiedUsersLoadedSelector = state => lodash.get(state, 'binderNotifiedUsers.loaded', false);
